import React from 'react';
import Lozenge from '@atlaskit/lozenge';
import { fg } from '@atlaskit/platform-feature-flags';
export var STATUS_TYPE_TEST_ID = 'link-datasource-render-type--status';
var StatusRenderType = function StatusRenderType(_ref) {
  var text = _ref.text,
    style = _ref.style,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? STATUS_TYPE_TEST_ID : _ref$testId;
  if (!(text && typeof text === 'string')) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  return /*#__PURE__*/React.createElement(Lozenge, {
    appearance: style === null || style === void 0 ? void 0 : style.appearance,
    isBold: fg('platform-component-visual-refresh') ? (style === null || style === void 0 ? void 0 : style.isBold) !== false : style === null || style === void 0 ? void 0 : style.isBold,
    testId: testId
  }, text);
};
export default StatusRenderType;